import { Controller } from "@hotwired/stimulus"

// Generic "show briefly then disappear" element. Fades out after delayValue
// ms, then DELETEs urlValue so the server doesn't re-render it on refresh.
export default class extends Controller {
  static values = {
    delay: { type: Number, default: 4000 },
    url: String
  }

  connect() {
    this.timer = setTimeout(() => this.dismiss(), this.delayValue)
  }

  disconnect() {
    if (this.timer) clearTimeout(this.timer)
  }

  async dismiss() {
    this.element.classList.add("opacity-0")
    setTimeout(() => this.element.remove(), 500)

    if (this.hasUrlValue) {
      try {
        await fetch(this.urlValue, {
          method: "DELETE",
          headers: {
            "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content
          }
        })
      } catch (e) {
        // Best-effort — server will just re-send the toast on next refresh
        // if the DELETE failed, which is acceptable.
      }
    }
  }
}
